import { Banner } from '../../../../../../types/banner';
import { BannerMetadataLine } from '../../../../../../types/library-metadata';
import { capitalize, getBannerDate } from '../../../../../../utils';

export const getBannerMetadata = (banner: Banner): BannerMetadataLine[] => {
  const { creativityConfig: config, title } = banner;
  const lines: BannerMetadataLine[] = [];

  const hasTeams = config && 'team1' in config && 'team2' in config && config.team1 && config.team2;
  const hasRound = config && 'round' in config && config.round;

  // Primera línea: equipos
  if (hasTeams) {
    lines.push({
      text: `${capitalize(config.team1)} vs ${capitalize(config.team2)}`,
      fontWeight: 'bold'
    });
  } else {
    lines.push({
      text: title || 'Asset',
      fontWeight: 'bold'
    });
  }

  // Segunda línea: ronda
  if (hasRound) {
    lines.push({
      text: `Ronda ${config.round}`
    });
  }

  // Fecha al final
  const dateText = getBannerDate(banner);
  if (dateText) {
    lines.push({
      text: dateText,
      fontSize: 'base'
    });
  }

  return lines;
};
